import { render } from "./GoogleSignIn.vue?vue&type=template&id=6374fa43"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__